import { browserSessionStorage, browserLocalStorage } from "./browser-storage.ts";
export type ThemeMode = "auto" | "light" | "dark";
export type ResolvedTheme = "light" | "dark";

const storageKey = "edubgt_theme_v2";
const legacyStorageKey = "edubgt_theme";
const eveningStartHour = 19;
const morningStartHour = 7;

export function readThemeMode(): ThemeMode {
  browserLocalStorage.removeItem(legacyStorageKey);
  browserLocalStorage.removeItem(storageKey);
  const value = browserSessionStorage.getItem(storageKey);
  return value === "light" || value === "dark" ? value : "auto";
}

export function saveThemeMode(mode: ThemeMode) {
  if (mode === "auto") {
    browserSessionStorage.removeItem(storageKey);
    return;
  }
  browserSessionStorage.setItem(storageKey, mode);
}

export function resolveThemeMode(mode: ThemeMode, date = new Date()): ResolvedTheme {
  if (mode !== "auto") return mode;
  const hour = date.getHours();
  return hour >= eveningStartHour || hour < morningStartHour ? "dark" : "light";
}

export function applyThemeMode(mode: ThemeMode) {
  const resolved = resolveThemeMode(mode);
  document.documentElement.dataset.theme = resolved;
  document.documentElement.dataset.themeMode = mode;
  document.documentElement.style.colorScheme = resolved;
}
